var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "34px",
    viewBox: "0 0 50 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Brand-/-Medium-/-data--Copy",
    transform: "translate(-7.000000, -15.000000)",
    fill: "#DA1E28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,15 C38.3101527,15 43.3213823,18.8581875 45.4265916,24.3442775 C45.5044321,24.5487883 45.6856974,24.6960572 45.9018605,24.7303792 C52.4944487,25.7774582 57,30.2461653 57,36.8 C57,43.823233 51.2990035,49 44,49 L44,49 L18,49 C11.4646998,49 7,45.4454831 7,39.2 C7,33.8157391 10.9532754,30.3217807 16.2697274,29.5300535 C16.5254129,29.4917186 16.7267919,29.292147 16.7673247,29.0374832 C18.1103424,20.5625782 24.3059998,15 32,15 Z M32,17 C25.3113859,17 19.9349106,21.8271011 18.7425696,29.3511826 C18.5648703,30.4676573 17.6843041,31.3403202 16.565296,31.5080925 C12.1359654,32.1677098 9,34.9393185 9,39.2 C9,44.2278962 12.4819391,47 18,47 L18,47 L44,47 C50.2351737,47 55,42.6733187 55,36.8 C55,31.3066948 51.2710264,27.6082149 45.5881862,26.7056282 C44.6646508,26.5589909 43.8900461,25.9296632 43.5583798,25.0582642 C41.7367964,20.3113008 37.4358937,17 32,17 Z M38,27 L39.4142136,28.4142136 L33.121,34.707 L39.4142136,41 L38,42.4142136 L31.707,36.121 L25.4142136,42.4142136 L24,41 L30.293,34.707 L24,28.4142136 L25.4142136,27 L31.707,33.293 L38,27 Z",
    id: "Combined-Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCloud);
export default __webpack_public_path__ + "static/media/no-cloud.c9180dc1b8460f8e726bdb53b5b01c6c.svg";
export { ForwardRef as ReactComponent };